module.exports = __webpack_public_path__ + "static/media/stransky.d0963320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/devdata/resources/stransky.jpg
// module id = 558
// module chunks = 0